<template>
  <li class="media bordered mb-2 p-2 p-sm-3 bg-white">
    <div class="media-body">
      <div class="d-flex flex-wrap flex-sm-nowrap flex-sm-row flex-column">
        <div class="pr-2 d-flex flex-column">
          <h5 class="mt-0 mb-0">
            <router-link class="c-dark-link first-letter-up d-block" :to="`/task/${item.id}`">{{item.label}}</router-link>
          </h5>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
  export default {
    name: "Task",
    props: {
      item: {
        type: Object,
        required: true
      }
    },
  }
</script>

<style lang="scss" scoped>
  .vacancy-item-right {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 130px;
    margin-left: auto;
    @media (max-width: 575px) {
      width: 100%;
      margin-top: 10px;
    }
    .btn {
      width: 130px;
    }
  }
</style>
